import _get from 'lodash/get';
import ValidityHint from '@lib/enums/validityHint';
import { CollapseCropColor } from '@lib/components/Collapse/Collapse';
import { TaskCompletionDetailsTableRow } from '../types';

export default function getCropColorByValidityHint(
  item: TaskCompletionDetailsTableRow,
): CollapseCropColor {
  const validityHint = _get(item, ['answer', 'validityHint']) as string;
  if (validityHint === ValidityHint.Failure) {
    return CollapseCropColor.Error;
  }
  if (validityHint === ValidityHint.Warning) {
    return CollapseCropColor.Warning;
  }
  return CollapseCropColor.White;
}
